import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Promotion } from 'src/app/models/promotion';
import { PosPromotionsDetailsModalComponent } from 'src/app/shared/pos-promotions-details-modal/pos-promotions-details-modal.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PosPromotionsDetailsModalService {

  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) { }

  show(promotion: Promotion): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      this.modalRef = this.modalService.show(PosPromotionsDetailsModalComponent,
        {
          ignoreBackdropClick: true
        })
      this.modalRef.setClass(`modal-dialog modal-lg ${ModalDialogType.PRIMARY}`)
      this.modalRef.content.promotion = promotion;
      this.modalRef.content.loadPromotionInformation();
      resolve(true);
    });
  }
}
